// Make $ refer to the current jQuery object in this context.
(function ($)
{

    // Sends a tracking event request to the custom-built Sitecore tracking API.
    function sendTrackingRequest(eventName, eventData, eventText)
    {

        // Test.
        //console.log("sendTrackingRequest(\"" + eventName  + "\", \"" + eventData + "\", \"" + eventText + "\")");

        // Make an AJAX post request.
        $.ajax(
            {
                "cache": false,
                "contentType": "application/x-www-form-urlencoded",
                "data": "name=" + eventName + "&data=" + eventData + "&text=" + eventText,
                "method": "POST",
                "url": "/api/sitecore/analytics/trackevent"
            }
        ).fail(function (jqXHR, textStatus, errorThrown)
        {
            console.log("Error: Event tracking request failed.");
            console.log("    status: " + textStatus);
            console.log("    error: " + errorThrown);
            console.log("    event name: " + eventName);
            console.log("    event data: " + eventData);
            console.log("    event text: " + eventText);
        }/*.done(function (data, textStatus)
        {
            console.log("Event tracking request succeeded.");
            console.log("    status: " + textStatus);
            console.log("    event name: " + eventName);
            console.log("    event data: " + eventData);
            console.log("    event text: " + eventText);
        })*/);

    }

    // Parse the data-tracking attributes for a given element into an event data object, filling out optional attributes as necessary.
    function parseTrackingAttributes(element)
    {

        // Set up variables.
        $element = $(element);
        var eventTriggersAttr = $element.attr("data-tracking");
        var eventTriggers = eventTriggersAttr !== undefined ? eventTriggersAttr.split(";") : [];
        var eventNamesAttr = $element.attr("data-tracking-name");
        var eventNames = eventNamesAttr !== undefined ? eventNamesAttr.split(";") : [];
        var eventDataAttr = $element.attr("data-tracking-data");
        var eventData = eventDataAttr !== undefined ? eventDataAttr.split(";") : [];
        var eventTextAttr = $element.attr("data-tracking-text");
        var eventText = eventTextAttr !== undefined ? eventTextAttr.split(";") : [];
        var pageEvents = [];

        // Iterate over event triggers specified in the main data-tracking attribute.
        for (var a = 0; a < eventTriggers.length; a++)
        {

            // Create an event item object to hold the event data.
            var eventItem = {
                trigger: eventTriggers[a],
                name: undefined,
                data: undefined,
                text: undefined
            };

            // Parse or fill out Sitecore event name.
            if
            (
                a < eventNames.length &&
                eventNames[a] !== ""
            )
            {
                eventItem.name = eventNames[a];
            }
            else
            {
                eventItem.name = capitalizeFirstLetter(eventTriggers[a]);
            }

            // Parse or fill out event data string.
            if
            (
                a < eventData.length &&
                eventData[a] !== ""
            )
            {
                eventItem.data = eventData[a];
            }
            else
            {
                if ($element.is("a[href]"))
                {
                    eventItem.data = $element.attr("href");
                }
                else
                {
                    var elementIdentifier = element.tagName.toLowerCase();
                    if (
                        element.id !== undefined &&
                        element.id !== ""
                    )
                    {
                        elementIdentifier += "#" + element.id;
                    }
                    eventItem.data = elementIdentifier;
                }
            }

            // Parse or fill out event text string.
            if
            (
                a < eventText.length &&
                eventText[a] != ""
            )
            {
                eventItem.text = eventText[a];
            }
            else
            {
                eventItem.text = $element.text();
            }

            // Add the event item to the list of page events.
            pageEvents.push(eventItem);

        }

        return pageEvents;

    }

    // Capitalize the first letter of a text string.
    function capitalizeFirstLetter(text)
    {
        return text.charAt(0).toUpperCase() + text.substr(1);
    }

    // Run this function when the window load event fires.
    $(function ()
    {

        // Set up a delegated click tracking event.
        $("body").on("click", "[data-tracking*=\"click\"]", function ()
        {

            $this = $(this);

            // Parse the data-tracking attributes, filling out optional attributes as necessary.
            var pageEvents = parseTrackingAttributes(this);

            // Verify that the exact "click" trigger is present for this element, and that this element wasn't picked up accidentally as a substring (e.g. "doubleclick").
            for (var a = 0; a < pageEvents.length; a++)
            {
                if (pageEvents[a].trigger === "click")
                {

                    // Send the tracking request.
                    sendTrackingRequest(pageEvents[a].name, pageEvents[a].data, pageEvents[a].text);
                    break;

                }
            }
            
        });

    });

})(jQuery);